import * as Yup from 'yup';
import React, { useState, useEffect } from "react"
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { FormProvider, RHFTextField } from '../hook-form';
import 'react-multi-carousel/lib/styles.css'
import 'bootstrap/dist/css/bootstrap.css'
import './signRegister.css'
import Iconify from '../Iconify';
import Footer from '../common/footer/Footer'
import Header from '../common/header/Header'
import { LoadingButton } from '@mui/lab';
import { Button, Stack, IconButton, InputAdornment, Box } from '@mui/material';
import { Link, useNavigate } from "react-router-dom"
import { register } from '../../api/auth';

import { ToastContainer, toast, Bounce } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// -------------------------------------------------

const SignRegister = () => {
  const navigate = useNavigate()
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [showError, setShowError] = useState();
  const [showLoader, setShowLoader] = useState();
  const notify = (message) => toast(message);
  const LoginSchema = Yup.object().shape({
    name: Yup.string().required('Name is Required'),
    password: Yup.string().required('Password is Required'),
    mobile: Yup.string().matches(/^\d{10}$/, 'must be 10 numbers').required('Mobile is required'),
    email: Yup.string().email().matches(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      , 'must be valid email').required('Email is required'),
    confirmPassword: Yup.string().required('Confirm password required')
  });

  const defaultValues = {
    email: '',
    password: '',
    email: '',
    mobile: '',
    confirmPassword: ''
  };

  const methods = useForm({
    resolver: yupResolver(LoginSchema),
    defaultValues,

  });

  const {
    watch,
    handleSubmit,
    formState: { isSubmitting },

  } = methods;
  const values = watch();
  const onSubmit = async (data) => {

    if (values.confirmPassword !== values.password) {
      alert('password and confirm password not match')
    } else {

      try {

        const response = await register(data)



        if (response.code === 201) {
          notify(response.message)
          setTimeout(() => {
            navigate('/login')
          }, 1000);

        } else {
          notify(response.message)
        }
      } catch (error) {
        notify(error.message)
      }


    }

  };

  console.log(values)
  return (
    <>
      <Header />
      <section className='py-5'>
        <div className='container'>
          <div className='row justify-content-center'>
            <div className='col-md-9'>
              <Box
                sx={{
                  backgroundColor: '#fff',
                  boxShadow: '0 2px 5px rgba(16, 16, 16, .09)',
                  p: 2,
                  borderRadius: '25px',
                }}
              >
                <div className='row'>
                  <div className='col-md-6'>
                    <img src='../images/signin.svg' />
                  </div>
                  <div className='col-md-6'>
                    <div className='accountSection'>
                      <img src='../images/logo.jpg' />
                      <h3>Create new account</h3>
                      <p className='pb-3'>Already a member? <Link to='/login'>Log In</Link></p>
                      <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
                        <Stack sx={{ py: 1 }}>
                          <RHFTextField size="small" name="name" label="Enter Name" />
                        </Stack>
                        <Stack sx={{ py: 1 }}>
                          <RHFTextField size="small" name="email" label="Enter Email" />
                        </Stack>
                        <Stack sx={{ py: 1 }}>
                          <RHFTextField size="small" type='number' name="mobile" label="Enter Mobile" />
                        </Stack>
                        <Stack sx={{ py: 2 }}>
                          <RHFTextField
                            name="password"
                            label="Password"
                            size="small"
                            type={showPassword ? 'text' : 'password'}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <IconButton edge="end" onClick={() => setShowPassword(!showPassword)}>
                                    <Iconify icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                                  </IconButton>
                                </InputAdornment>
                              ),
                            }}
                          />
                        </Stack>
                        <Stack sx={{ py: 1 }}>
                          <RHFTextField
                            name="confirmPassword"
                            label="Confirm Password"
                            size="small"
                            type={showConfirmPassword ? 'text' : 'password'}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <IconButton edge="end" onClick={() => setShowConfirmPassword(!showConfirmPassword)}>
                                    <Iconify icon={showConfirmPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                                  </IconButton>
                                </InputAdornment>
                              ),
                            }}
                          />
                        </Stack>
                        <Stack sx={{ py: 1 }}>
                          <LoadingButton fullWidth size="large" type="submit" className='signBtn' loading={isSubmitting}>
                            Sign Up
                          </LoadingButton>
                        </Stack>
                      </FormProvider>
                    </div>
                  </div>
                </div>
              </Box>
            </div>
          </div>
        </div>
      </section>
      <ToastContainer />

      <Footer />
    </>
  )
}

export default SignRegister
